import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_BASE ||
  (typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:9999"
    : "");

const api = axios.create({ baseURL, timeout: 60000 });

api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("ozzy_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch (e) {}
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      try { localStorage.removeItem("ozzy_admin_token"); } catch (e) {}
    }
    return Promise.reject(err);
  }
);

export { baseURL };

export function mediaUrl(url) {
  if (!url) return "";
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith("/")) return `${baseURL}${url}`;
  return `${baseURL}/${url}`;
}

export default api;
